// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w8ZO","content":"styles_content__2MwDZ"};